/**
 * 用户相关接口
 */
const PREFIX = 'checkmall-file'
let fileApi = {
  /**
   * 接口模块 前缀
   */
  prefix: PREFIX,
  url: {
    /**文件上传 */
    fileUpload: '/api/file/upload',
    /**文件下载 */
    fileDownload: '/api/file/downloadFile',
  },
}
export default fileApi
